import React from 'react'

import { CommandBar } from './CommandBar'
import { useCommandBar } from '../context'

export const CommandBarHost = () => {
  const {
    error,
    isAvailable,
    isOpen,
    items,
    loading,
    closeCommandBar,
    onQueryChange,
    query,
    runItem,
    submenuTitle,
    onBack,
  } = useCommandBar()

  if (!isAvailable) {
    return null
  }

  return (
    <CommandBar
      isOpen={isOpen}
      items={items}
      loading={loading}
      error={error}
      query={query}
      onQueryChange={onQueryChange}
      onClose={closeCommandBar}
      onRunItem={runItem}
      submenuTitle={submenuTitle}
      onBack={onBack}
    />
  )
}
